/*
 * Copyright (C) 2024 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component } from '@angular/core';

@Component({
  selector: 'ptl-skeleton-report-list-item',
  templateUrl: './skeleton-report-list-item.component.html',
  styleUrls: ['./skeleton-report-list-item.component.scss'],
})
export class SkeletonReportListItemComponent {}
